import { TableWitPagination } from 'dash-ui';
import styled from 'styled-components';

export const TableWitPaginationWraper = styled(TableWitPagination)`
  width: 100%;
  @media ${({ theme }) => theme.devices.mobile} {
    width: 950px;
  }
`;
